export default __webpack_public_path__ + "static/media/flow.9f5f9428.gif";